import React from 'react';
import { CaseCloseRules } from '../components';

export default () => {
    return (
        <CaseCloseRules.Home />
    )
}